<template>
    <div>
      <v-layout row wrap justify-center align-center text-xs-center pb-5 mt-5 class="cont_page">
        <v-flex xs12 sm9 md7 mt-4 class="text-xs-left">
              <h1 class="animated bounceIn dura-1"><span class="icon-titulo"></span>Pasos para la calibración de los equipos</h1>    
              <h2 class="animated bounceIn dura-2">Kit de calibración</h2>
        </v-flex> 
        <v-flex xs12 sm9 md7 mt-3 class="text-xs-left"> 
          <p>Son los elementos utilizados para calibrar el equipo portátil para prueba de gases. También se podrá contar con Estaciones automáticas de calibración.</p> 
          <p>El kit de calibración está conformado por:</p> 
          <v-layout row wrap justify-center align-center text-xs-center pb-5 class="cont_page"> 
          <v-flex> 
            <svg-app v-show="!$vuetify.breakpoint.xs"></svg-app > 
            <!-- <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-4-1.png')" alt="" v-show="!$vuetify.breakpoint.xs"> -->
          </v-flex> 
          <v-flex>
            <!-- <img class="animated flipInY dura-1" :src="require('../../assets/unidad2/pantalla-4-1-mobile.png')" alt="" v-show="$vuetify.breakpoint.xs"> -->
            <svg1-app v-show="$vuetify.breakpoint.xs"></svg1-app > 
          </v-flex> 
          </v-layout>
          <ul class="items">
              <li>Un cilindro que contiene el gas patrón, el cual puede ser: mezcla de 4 gases, el establecido por el fabricante o cada gas por separado, por ejemplo, H2S e Isobutileno. </li>
              <li>Un regulador de flujo que permite el paso del gas de la botella al equipo y mide la presión o cantidad de gas en el cilindro.</li>
              <li>Una manguera para conectar al regulador y al equipo.</li>
          </ul><br>
          <scrolldown-app></scrolldown-app>
          <p><strong>Nota:</strong> Los elementos del kit de calibración varían según tipo de equipo a calibrar, ya que no todos los equipos tienen los mismos sensores o las mismas características. </p> 
      </v-flex>
      <v-flex xs12 sm9 md7 mt-3 class="text-xs-left">
          <span><strong>Niveles de alarmas de oxígenos,  gases inflamables y tóxicos</strong></span>  
          <table class="tabla">
        <caption></caption> 
        <thead>
        <tr class="encabezado">
        <th scope="col" align="left">Gases</th>
        <th scope="col" align="left">Nivel de alarma (sonora y visual)</th>
        </tr>
        </thead>
        <tbody>
          <tr class="fila1">
            <td align="left">Gas o vapor inflamable o combustible rango de medición: 0-100% en LEL</td>
            <td align="left">1ª alarma= 10% LEL y 2ª alarma= 20% LEL.</td>
          </tr>
          <tr>
            <td align="left">Oxígeno Rango de medición 0-25% en volumen.(ver rango fabricante)</td>
            <td align="left">19.5% vol. Por deficiencia y 23% vol. Por enriquecimiento.</td>
          </tr>
          <tr>
            <td align="left">Monóxido de carbono “CO”Rango de medición: 0-999 ppm.(ver rango fabricante)</td>
            <td align="left">1ª alarma = 75 ppm y 2ª alarma = 175 ppm.</td>
          </tr>
          <tr>
            <td align="left">Ácido sulfhídrico “H2S” Rango de medición: 0-200 ppm. (rango fabricante)</td>
            <td align="left">1ª alarma = 5 ppm y 2ª alarma = 15 ppm.</td>
          </tr>
        </tbody>
        </table>
      </v-flex>
      <v-flex mt-2 xs12 sm9 md7 mt-3 class="text-xs-left">
        <p >Hay equipos portátiles que tienen la posibilidad de instalarles un sensor adicional para detectar otro gas, por ejemplo, Cloro (Cl), Óxido de azufre (SO2), etc. </p>
      </v-flex>
      </v-layout>
    </div>
  </template>
  <script>
  import nextConditions from "../../js/mixins/nextConditions";
  import svg from "./svg/pantalla3";
  import svg1 from "./svg/pantalla3-1";
  export default {
    components: {
      "svg-app": svg,
      "svg1-app": svg1,
    },
    mixins: [nextConditions],
    data() {
      return {
      }
    },
    mounted() {
      setTimeout(() => {
        this.$store.commit('nextShow', true);
      },3000);
    },    
  }
  
  </script>
  <style lang="scss" scoped>
  @import '../../sass/globals';
  .encabezado{
    background: #c7ee95ff;
  }
  td, th {
    border: #23cad9ff 1px solid;
    font-size: 13.6px;
  }
  </style>
  